import { render, staticRenderFns } from "./SelectedAttributesPage.vue?vue&type=template&id=24c6e6f6&scoped=true"
import script from "./SelectedAttributesPage.vue?vue&type=script&lang=js"
export * from "./SelectedAttributesPage.vue?vue&type=script&lang=js"
import style0 from "./SelectedAttributesPage.vue?vue&type=style&index=0&id=24c6e6f6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c6e6f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24c6e6f6')) {
      api.createRecord('24c6e6f6', component.options)
    } else {
      api.reload('24c6e6f6', component.options)
    }
    module.hot.accept("./SelectedAttributesPage.vue?vue&type=template&id=24c6e6f6&scoped=true", function () {
      api.rerender('24c6e6f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/components/SelectedAttributesPage.vue"
export default component.exports